import { useState } from "react";
import { McpWizard } from "../McpWizard/mcp-wizard";
import { Modal } from "~/components/Modal";
import type { McpClientId, McpCredential } from "../../lib/mcp-clients";

// // // //

/**
 * McpWizardModal
 * Dialog wrapper for the MCP connection wizard.
 */
export function McpWizardModal(props: {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    generating: boolean;
    generate: (name: string, client: McpClientId) => Promise<McpCredential>;
    initialClient: McpClientId;
}) {
    const { open, onOpenChange, generating, generate, initialClient } = props;

    const [wizardKey, setWizardKey] = useState(0);

    const handleComplete = () => {
        setWizardKey((current) => current + 1);
        onOpenChange(false);
    };

    // Only allow close when the user is on the first step
    const allowClose = wizardKey === 0 && !generating;

    return (
        <Modal
            show={open}
            size="lg"
            allowClose={allowClose}
            onHide={() => {
                if (allowClose) {
                    onOpenChange(false);
                }
            }}
        >
            {/* Keying on the initial client remounts the wizard when it is
                reopened from a different client selection. */}
            <McpWizard
                key={`${wizardKey}-${initialClient}`}
                generate={generate}
                onComplete={handleComplete}
                initialClient={initialClient}
            />
        </Modal>
    );
}
